import './index.less';

import classNames from 'classnames';
import { forwardRef, Ref, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

const FeedbackErrorDialog = (
  {
    isUpload,
    isManySubmission,
  }: { isUpload: boolean; isManySubmission: boolean },
  ref: Ref<any>,
) => {
  const { t: $t, i18n } = useTranslation('user-feedback');
  const [show, setShow] = useState(false);
  const [title, setTile] = useState('');
  const [content, setContent] = useState('');

  useImperativeHandle(ref, () => ({
    open: (title: string, content: string) => {
      setTile(title || '');
      setContent(content || '');
      setShow(true);
    },
  }));

  const handlerOk = () => {
    setShow(false);
  };

  const preventScroll = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const specialStyle = () => {
    if (isUpload) {
      return [
        'ru-RU',
        'es-ES',
        'pt-BR',
        'fr-FR',
        'ja-JP',
        'tr-TR',
        'id-ID',
      ].includes(i18n.language);
    }
  };

  const specialManyStyle = () => {
    if (isManySubmission) {
      return [
        'ru-RU',
        'es-ES',
        'vi-VN',
        'tr-TR',
        'pt-BR',
        'fr-FR',
        'th-TH',
        'id-ID',
      ].includes(i18n.language);
    }
  };

  return show ? (
    <div className="feedback-mask" onWheel={preventScroll}>
      <div
        className={classNames('feedback-dialog', {
          'feedback-dialog-special': specialStyle(),
          'feedback-dialog-many': specialManyStyle(),
        })}
      >
        <img src="/images/user-feedback/fail.svg" alt="" />
        {title ? <p className="feedback-dialog-title">{title}</p> : null}
        <p className="feedback-dialog-content">{content}</p>
        <span className="feedback-dialog-btn" onClick={handlerOk}>
          {$t('newFeedbackInOkay')}
        </span>
      </div>
    </div>
  ) : null;
};

export default forwardRef(FeedbackErrorDialog);
